import NProgress from 'nprogress';
NProgress.configure({showSpinner: false, speed: 1000})
export default (store) => {
    store.subscribe((mutation) => {
    if (mutation.type.includes("_LOADING")) {
        if(mutation.payload){
            NProgress.start();

        }
        else{
            NProgress.done();
        }
    }
    });
    };